import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, take } from 'rxjs';
import { environment } from 'oneok/environments/environment';

interface PortalInvitationRedeemPayload {
  Username: string;
  Firstname: string;
  Lastname: string;
  Email: string;
  Pin?: string;
  CompanyName: string;
  AccountId: string;
  Id: string;
  Phone: string;
  InviteCode: string;
  IsCusUser: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class Register {
  baseUrl = environment.apiUrlV2;
  private readonly _http = inject(HttpClient);

  sendInvitationToAccountContact(
    contactId: string,
    accountId: string,
    firstName: string,
    lastName: string,
    senderId: string
  ): Observable<any> {
    const payload = {
      AccountId: accountId,
      ContactId: contactId,
      SenderId: senderId,
      FirstName: firstName,
      LastName: lastName
    };
    return this._http.post(this.baseUrl + `/portalinvitation/${accountId}`, payload).pipe(take(1));
  }

  validatePortalInvitation(invitationCode: string, submittedEmail: string): Observable<any> {
    const payload = {
      InviteCode: invitationCode,
      EmailId: submittedEmail
    };
    return this._http.post(this.baseUrl + '/portalinvitation/validate', payload);
  }

  inviteCodePortalInvitation(invitationPayload: PortalInvitationRedeemPayload): Observable<any> {
    return this._http.put(this.baseUrl + '/portalinvitation/redeem', invitationPayload);
  }
}
